import React from 'react';
import { Observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { useGetRecord } from 'root/admin/components/hooks';
import { VideoPlayer, Title, Thumbnail } from 'root/admin/components';
import store from 'root/admin/store';
import { DatePicker, Form, Field, Loader, Row, ManyToManySelect, FileInput } from '@smartplatform/ui';

const ArticleEdit = ({ match, rootPath, tabName }) => {
	const { id } = match.params;
	const options = {};
	const record = useGetRecord({ model: 'Media', id, options, tabName });

	if (!record) {
		return <Loader />;
	}

	if (record && !record.id) {
		record.publishAt = new Date();
	}

	const onSave = () => {
		if (isNaN(id)) {
			store.history.push(`${rootPath}/media/${record.id}`);
			store.ui.setNotification({ message: 'Запись создана' });
		} else {
			store.history.push(`${rootPath}/media`);
			store.ui.setNotification({ message: 'Запись сохранена' });
		}
	};

	const onDelete = async () => {
		store.history.push(`${rootPath}/media`);
	};

	console.log(record);

	return (
		<div>
			<Title record={record} name="Видео" />
			<Form record={record} rootPath={rootPath} onSave={onSave} onDelete={onDelete} stay>
				<Field property="name" label="Название" />
				<Row>
					<Field property="publishAt" label="Дата и время публикации">
						<DatePicker showTimeSelect timeIntervals={15} />
					</Field>
					<Field property="removeAt" label="Дата и время снятия с публикации">
						<DatePicker showTimeSelect timeIntervals={15} />
					</Field>
				</Row>
				<Row>
					<Field property="publish" label="Опубликовать" />
				</Row>
				<Field label="Метки">
					<ManyToManySelect
						relation="tags"
						computed={type => <span title={type.id}>{type.name}</span>}
						itemTag={type => <span title={type.id}>{type.name}</span>}
						searchFields={['name']}
						filter={{ where: { type: { inq: ['media', 'all'] } } }}
					/>
				</Field>
				<Thumbnail record={record} label="Обложка альбома" />
				<Row>
					<Field property="videoUrl" label="URL Видеофайла"></Field>
				</Row>

				<Observer>
					{() => (
						<Field label="Видеопревью">
							<VideoPlayer
								autoPlay={false}
								show={!!record.videoUrl}
								key={record.videoUrl}
								url={record.videoUrl}
							/>
						</Field>
					)}
				</Observer>
			</Form>
		</div>
	);
};

export default withRouter(ArticleEdit);
